/**
 * Phase 3 convergence anchor — the ONE shared derivation of a task answer's
 * durable per-message-doc key.
 *
 * Kept in its own ZERO-dependency module (no Firestore, no firebase/auth, no
 * React) so the pure reducer/persist hot paths — `interruptedTurn.ts`,
 * `streamFinalizePersist.ts` — can freeze the anchor without dragging the
 * firebase SDK into their import graph. `chatThreadMessageDocFirestore.ts`
 * re-exports it so existing call sites are unchanged.
 */

/**
 * The stable per-doc key for a server-backed answer: `prest0n_task_<serverTaskId>`.
 * Returns null when there is no server task (a plain message keys by its own id).
 * This exact format is what the server stamps as `recoveredMessageId`, so the
 * client and server writers converge on a single Firestore document.
 */
export function deriveTaskAnchorId(serverTaskId: string | null | undefined): string | null {
  const t = typeof serverTaskId === 'string' ? serverTaskId.trim() : '';
  return t ? `prest0n_task_${t}` : null;
}
